import FJCoreConfig from '../core/FJCoreConfig.js';

let _maxOverride = null;

/**
 * 当前允许并行的人脸检测任务数（至少为 1）。
 * @returns {number}
 */
function getMaxConcurrent() {
    if (_maxOverride != null) {
        return _maxOverride;
    }
    const c = FJCoreConfig.FACE_DETECT_MAX_CONCURRENT;
    return Math.max(1, Math.floor(typeof c === 'number' && c >= 1 ? c : 1));
}

/** @type {{ task: () => Promise<unknown>, resolve: (v: unknown) => void, reject: (e: unknown) => void }[]} */
const queue = [];
let running = 0;

function pump() {
    const max = getMaxConcurrent();
    while (running < max && queue.length > 0) {
        const { task, resolve, reject } = queue.shift();
        running += 1;
        Promise.resolve()
            .then(() => task())
            .then(
                v => {
                    running -= 1;
                    resolve(v);
                    pump();
                },
                e => {
                    running -= 1;
                    reject(e);
                    pump();
                },
            );
    }
}

/**
 * 全局人脸检测任务调度器：所有 `FJDetailManager.startDetectFace` 经此串行/限并发执行。
 * 若需与产品配置对齐，在 `FJCoreConfig` 中设置 `FACE_DETECT_MAX_CONCURRENT`（默认 1），或运行期调用 `configure`。
 */
const FJFaceDetectScheduler = {
    /**
     * @param {{ maxConcurrent?: number } | null} [opts] 传 `null` 或 `configure(null)` 可清除覆盖，改回仅读 FJCoreConfig
     */
    configure(opts) {
        if (opts == null) {
            _maxOverride = null;
            return;
        }
        if (opts && opts.maxConcurrent != null) {
            const n = Math.floor(Number(opts.maxConcurrent));
            _maxOverride = Number.isFinite(n) && n >= 1 ? n : 1;
        }
    },

    getMaxConcurrent,

    getQueuedCount() {
        return queue.length;
    },

    getRunningCount() {
        return running;
    },

    /**
     * 将单段人脸分析（取片源、解码+检测、写回）作为一体任务；超过并发上限时排队 FIFO。
     * @template T
     * @param {() => Promise<T>} task
     * @returns {Promise<T>}
     */
    run(task) {
        return new Promise((resolve, reject) => {
            queue.push({ task, resolve, reject });
            pump();
        });
    },
};

export default FJFaceDetectScheduler;
